import { FormInput, SelectInput } from '@policoders/ds';
import { useEffect, useState } from 'react';

import { MeasureUnitType } from '../../../types/measure-unit.type';
import { PurchaseOrderItem } from './purchase-order.model';

type IProps = {
  data: PurchaseOrderItem;
  onChange: (data: PurchaseOrderItem) => void;
};

const PurchaseOrderItemForm = ({ data, onChange }: IProps) => {
  const [state, setState] = useState<PurchaseOrderItem>(data);

  const handleChange = (e: any) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    onChange && onChange(state);
  }, [onChange, state]);

  const measureUnitTypes = () => {
    var items = Object.keys(MeasureUnitType);
    var values = Object.values(MeasureUnitType);
    return [
      { label: '', value: '' },
      ...items.map((item, i) => ({
        label: item.replace('_', ' '),
        value: values[i],
      })),
    ];
  };

  return (
    <div>
      <div className="row">
        <div className="col-6">
          <FormInput
            type="text"
            label="Produto"
            field="productName"
            value={state.productName}
            onChange={handleChange}
          />
        </div>
        <div className="col">
          <SelectInput
            label="Unid. medida"
            field="measureUnit"
            value={state.measureUnit}
            options={measureUnitTypes()}
            onChange={handleChange}
          />
        </div>
        <div className="col">
          <FormInput
            type="number"
            label="Quantidade"
            field="quantity"
            value={state.quantity}
            onChange={handleChange}
          />
        </div>
        <div className="col">
          <FormInput
            type="number"
            label="Preço unitário"
            field="unitPrice"
            value={state.unitPrice}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderItemForm;
